import { InvitationShare, ConfigProvider } from '@felo/ui'
import { Col, message, Row, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import { LOCAL_LANG, ROW_JUSTIFY } from '../common/const'
import { tranTimestamp, UrlQueryParamsParse } from '../common/globalFun'
import API from '../config/api'
import { GetErrMsg } from '../config/errCode'
import { PostEmailInvite } from '../config/request'
import PageBg from '../components/PageBg'
import './css/style.css'

const emptyState = {
  expiredAt: '',
  link: '',
  code: '',
  organizationName: '',
  userName: '',
}

const InviteShare = (props) => {
  const { history } = props
  const intl = useIntl()
  const [userportalToken, setUserPortalToken] = useState('')
  const [orgCode, setOrgCode] = useState('')
  const [account, setAccount] = useState('')
  const [data, setData] = useState(emptyState)

  const resetWindowOpen = () => {
    window.open = (function (open) {
      return function (url, name, features) {
        if (
          window.FeloSDK &&
          (window.FeloSDK.isWindows || window.FeloSDK.isMac)
        ) {
          window.FeloSDK.openBrowser(url)
        } else {
          return open.call(window, url, name, features)
        }
      }
    })(window.open)
  }

  // 身份验证token 转成 V4 JWT token
  const getV4Token = (token) => {
    const param = {
      header: {
        token: token,
      },
    }

    fetch(API.GET_JWT_TOKEN_V4, {
      method: 'POST',
      body: JSON.stringify(param),
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        const { status, jwtToken } = rsp

        if (status.code === 0) {
          props.setGlobalToken(jwtToken)
        } else {
          message.error(status.message)
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  // 身份验证token 转成 userportal JWT token
  const getUserPortalToken = (token) => {
    fetch(API.GET_TOKEN, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        token: token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        if (rsp.errCode === '0000') {
          setUserPortalToken(rsp.token)

          const { userInfo } = rsp

          if (userInfo) {
            const { username, account } = userInfo

            setAccount(account)
            setData((prev) => ({
              ...prev,
              userName: username,
            }))
          }
        } else {
          message.error(GetErrMsg(rsp.errCode))
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  // get url link
  const getUrlLink = (isRest) => {
    const param = {
      path: '/invite/member', //组织链接分享专用path
      reset: isRest, //重置分享链接
    }

    fetch(API.GET_SHARE_LINK, {
      method: 'POST',
      body: JSON.stringify(param),
      headers: new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        timestamp: new Date().getTime().toString(),
        Authorization: props.token,
      }),
    })
      .then((response) => response.json())
      .then((rsp) => {
        const { data, status } = rsp

        if (status && status.errCode === '0000') {
          const { linkUrl, expireTime, extraData } = data

          setData((prev) => ({
            ...prev,
            expiredAt: tranTimestamp(expireTime),
            link: linkUrl,
            code: data.inviteCode,
            organizationName: extraData.teamName,
          }))

          setOrgCode(extraData.teamCode)

          if (isRest) {
            message.success(intl.formatMessage({ id: 'reset.success' }))
          }

          resetWindowOpen()
        } else {
          message.error(GetErrMsg(rsp.errCode))
        }
      })
      .catch((error) => {
        message.error(JSON.stringify(error))
      })
  }

  // 发送邀请接口
  const handleSendEmail = (emails) => {
    return PostEmailInvite({
      accounts: emails,
      lang: LOCAL_LANG[intl.locale],
      corpId: orgCode,
      token: userportalToken,
      email: account,
    }).then((rsp) => {
      if (rsp.data.failedEmailLis && rsp.data.failedEmailLis.length > 0) {
        return {
          failed: rsp.data.failedEmailLis.map((item) => ({
            email: item.email,
            code: item.code,
          })),
        }
      }

      return {
        failed: [],
      }
    })
  }

  useEffect(() => {
    const { search } = props.location
    const urlQueryParamsStr = search.replace(/^\?/, '')
    const queryParamsData = UrlQueryParamsParse(urlQueryParamsStr)

    if (queryParamsData && queryParamsData.token) {
      const identifyToken = decodeURIComponent(queryParamsData.token)

      getV4Token(identifyToken)
      getUserPortalToken(identifyToken)
    }
  }, [props.location])

  useEffect(() => {
    if (props.token) {
      getUrlLink(false)
    }
  }, [props.token])

  return (
    <>
      <PageBg />
      <ConfigProvider lang={intl.locale}>
        {!data.code ? (
          <Row
            justify={ROW_JUSTIFY}
            className={'height-full'}
            style={{ paddingTop: '30px' }}
          >
            <Spin spin />
          </Row>
        ) : (
          <Row
            justify={ROW_JUSTIFY}
            className={'height-full'}
            style={{ paddingTop: '20px' }}
          >
            <Col span={23} sm={18} style={{ maxWidth: '600px' }}>
              <InvitationShare
                dialog={false}
                type="JoinOrganization"
                data={{
                  ...data,
                  onSendEmail: handleSendEmail,
                }}
              />
            </Col>
          </Row>
        )}
      </ConfigProvider>
    </>
  )
}

const stateProps = (state) => {
  return {
    token: state.token,
    email: state.email,
    loginKey: state.loginKey,
  }
}

const dispatchProps = (dispatch) => ({
  setGlobalToken: (token) => {
    dispatch({
      type: 'setToken',
      value: token,
    })
  },
})

export default connect(stateProps, dispatchProps)(InviteShare)
